import { IRepresentativesProfile } from 'shared/interfaces/IRepresentatives';
import {
  RepresentativesListItemAvatar,
  RepresentativesListItemAvatarContainer,
  RepresentativesListItemContainer,
  RepresentativesListItemDetailsContainer,
  RepresentativesListItemProgressBarContainer,
  RepresentativesListItemPrimaryTagContainer,
  RepresentativesListItemPrimaryTagText,
  RepresentativesListItemProgressBar,
  RepresentativesListItemPrivateText,
} from './RepresentativesListItem.styles';
import { getRepresentativesDetails } from 'pages/Representatives/utils/getRepresentativesDetails';
import { TypographyTooltip } from 'pages/Representatives/components/TypographyTooltip';
import { CircularProgress, IconButton } from '@material-ui/core';
import { memo } from 'react';
import { useImageLoader } from 'pages/Representatives/features/AddRepresentatives/hooks/useImageLoader';
import { Skeleton } from '@material-ui/lab';
import { ROUTES } from 'shared/constants/ROUTES';
import { CameraIconTwoTone } from '@room-match/shared-ui-components';
import { CameraIconButton } from 'pages/Representatives/Representatives.styles';

type RepresentativesListItemProps = {
  profile: IRepresentativesProfile;
  handlePrimaryChange: (profileId: string, primaryImage: string) => void;
  primaryTagLoading?: boolean;
  primaryTagDisable?: boolean;
  removeTag?: boolean;
  handlePrimaryImageUpload?: VoidFunction;
};

const RepresentativesListItem = ({
  profile,
  handlePrimaryChange,
  primaryTagLoading = false,
  primaryTagDisable = false,
  removeTag,
  handlePrimaryImageUpload,
}: RepresentativesListItemProps) => {
  // Destructure the profile
  const { stage_name, represented_name, division_name, contact_number, country } = getRepresentativesDetails({
    talent: profile.talent,
    agency: profile.agency,
    division: profile?.division,
    representation_type: profile?.representation_type,
    casting_private: profile?.casting_private,
    casting_company: profile.casting_company,
  });

  // Avatar
  const avatar =
    profile?.primary_medium_attachment?.modified_attachment || profile?.primary_medium_attachment?.attachment || '';

  const { src, loading } = useImageLoader(avatar);
  return (
    <li style={{ listStyle: 'none' }}>
      <RepresentativesListItemContainer
        style={{ ...(!removeTag && { marginTop: 20 }) }}
        to={removeTag ? '#' : `${ROUTES.TALENT.REPRESENTATIVES}/${profile.id}`}
        onClick={(e: any) => (removeTag ? e.preventDefault() : undefined)}
      >
        {/* Primary Tag */}
        {/* {removeTag ? null : (
          <RepresentativesListItemPrimaryTagContainer
            disabled={primaryTagDisable && !profile?.primary}
            onClick={(e) => {
              e.preventDefault();
              handlePrimaryChange(profile.id, profile?.primary_medium_attachment?.modified_attachment || '');
            }}
            primary={profile?.primary || false}
          >
            {primaryTagLoading ? (
              <CircularProgress size={15} />
            ) : (
              <RepresentativesListItemPrimaryTagText>
                {profile?.primary ? 'Primary' : 'Make Primary'}
              </RepresentativesListItemPrimaryTagText>
            )}
          </RepresentativesListItemPrimaryTagContainer>
        )} */}

        {/* Representatives Avatar */}
        <RepresentativesListItemAvatarContainer>
          {loading ? (
            <Skeleton
              variant="rect"
              width={'100%'}
              height={'100%'} // Set the height as needed
              style={{ borderRadius: 4 }}
            />
          ) : null}
          <RepresentativesListItemAvatar
            style={{ display: loading ? 'none' : 'block' }}
            src={src}
            alt={`${stage_name} primary image`}
          />
          {handlePrimaryImageUpload && !loading ? (
            <CameraIconButton
              style={{ bottom: 10, right: 10, fontSize: 14, padding: 2 }}
              onClick={(e) => {
                handlePrimaryImageUpload();
              }}
            >
              <CameraIconTwoTone fontSize="inherit" />
            </CameraIconButton>
          ) : null}
        </RepresentativesListItemAvatarContainer>

        {/* Representatives Details */}
        <RepresentativesListItemDetailsContainer>
          {profile?.casting_private ? (
            <RepresentativesListItemPrivateText>Private</RepresentativesListItemPrivateText>
          ) : null}
          <TypographyTooltip variant="h3">{stage_name}</TypographyTooltip>
          <TypographyTooltip variant="subtitle1" color="primary">
            {represented_name}
          </TypographyTooltip>
          {division_name ? (
            <TypographyTooltip variant="subtitle1" style={{ fontWeight: 700 }}>
              {division_name}
            </TypographyTooltip>
          ) : null}
          {contact_number ? <TypographyTooltip variant="subtitle1">{contact_number}</TypographyTooltip> : null}
          {country ? <TypographyTooltip variant="subtitle1">{country}</TypographyTooltip> : null}
        </RepresentativesListItemDetailsContainer>

        {/* Representatives Circular Progress Bar */}
        <RepresentativesListItemProgressBarContainer>
          <RepresentativesListItemProgressBar
            value={profile?.completeness || 0}
            text={`${profile?.completeness || 0}%`}
            completeness={profile?.completeness || 0}
          />
        </RepresentativesListItemProgressBarContainer>
      </RepresentativesListItemContainer>
    </li>
  );
};

export default memo(RepresentativesListItem);
